<script>

import { getBusinessLayerByBlId } from '@/model/dataLayer/api/Vip/BusinessLayer'
import GlobalConfig from '@/model/global/GlobalSettings'
import DisplayInfo from '@/views/AadenPages/VipPage/UserCenter/DisplayInfo.vue'
import ContactInfo from '@/views/AadenPages/VipPage/UserCenter/ContactInfo.vue'
import QrcodeVue from 'qrcode.vue'
import { VFileInput, VSwitch } from 'vuetify/lib/components'
import ColorPicker from '@/views/AadenPages/components/ColorPicker.vue'
import BaseForm from '@/model/baseForm/BaseForm/BaseForm.vue'
import { saveFile } from '@/model/utils/utils'
import { updateBusinessLayerDisplayInfo } from '@/model/dataLayer/api/Vip/VipUser'
import FileSaver from 'file-saver'
import OrganizationCard from '@/views/AadenPages/VipPage/UserCenter/OrganizationCard.vue'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'

export default {
  name: 'BlInfo',
  components: { LoadingProvider, OrganizationCard, BaseForm, QrcodeVue, ContactInfo, DisplayInfo },
  data () {
    return {
      loading: false,
      btnLoading: false,
      showEditDialog: false,
      blInfo: {}
    }
  },
  async mounted () {
    await this.reload()
  },
  computed: {
    schema () {
      return [
        {
          key: 'name',
          name: 'name'
        },
        {
          key: 'description',
          name: 'description',
          required: false,
          default: ''
        },
        {
          key: 'imageUrl',
          name: 'imageUrl',
          required: false,
          component: VFileInput
        },
        {
          key: 'color',
          name: 'color',
          component: ColorPicker,
          required: false
        },
        {
          key: 'public',
          name: 'public',
          component: VSwitch,
          default: true
        },
        {
          key: 'legalName',
          name: 'legalName',
          required: false,
          default: ''
        },
        {
          key: 'addressLine1',
          name: 'addressLine1',
          required: false,
          default: ''

        },
        {
          key: 'addressLine2',
          name: 'addressLine2',
          required: false,
          default: ''

        },
        {
          key: 'city',
          name: 'city',
          required: false,
          default: ''

        },
        {
          key: 'postalCode',
          name: 'postalCode',
          required: false,
          default: ''

        },
        {
          key: 'country',
          name: 'country',
          required: false,
          default: ''

        },
        {
          key: 'taxNumber',
          name: 'taxNumber',
          required: false,
          default: ''

        },
        {
          key: 'longitude',
          name: 'longitude',
          required: false,
          default: ''

        },
        {
          key: 'latitude',
          name: 'latitude',
          required: false,
          default: ''
        }
      ]
    },
    QRCode () {
      return 'aaden:' + btoa('blId/' + GlobalConfig.blId)
    }
  },
  methods: {
    // 门店成员（店长等）改在 Portal 用绑定码添加：这里的老邀请接口是匿名的，能被拿来冒充店主
    openPortal () {
      window.open('https://portal.aaden.io', '_blank')
    },
    async downloadQR () {
      this.btnLoading = true
      const QRBody = 'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=' + this.QRCode
      try {
        const response = await fetch(QRBody)
        const blob = await response.blob()
        FileSaver.saveAs(blob, 'qrcode.png')
      } catch (error) {
        console.error('下载失败:', error)
      }
      this.btnLoading = false
    },
    async reload () {
      this.loading = true
      this.blInfo = (await getBusinessLayerByBlId(GlobalConfig.blId))
      this.blInfo.legalName = this.blInfo.contactInfo.legalName
      this.blInfo.addressLine1 = this.blInfo.contactInfo.addressLine1
      this.blInfo.addressLine2 = this.blInfo.contactInfo.addressLine2
      this.blInfo.city = this.blInfo.contactInfo.city
      this.blInfo.postalCode = this.blInfo.contactInfo.postalCode
      this.blInfo.country = this.blInfo.contactInfo.country
      this.blInfo.taxNumber = this.blInfo.contactInfo.taxNumber
      this.blInfo.longitude = this.blInfo.contactInfo.longitude
      this.blInfo.latitude = this.blInfo.contactInfo.latitude
      this.blInfo.name = this.blInfo.displayInfo.name
      this.blInfo.description = this.blInfo.displayInfo.description
      this.blInfo.imageUrl = this.blInfo.displayInfo.imageUrl
      this.blInfo.color = this.blInfo.displayInfo.color
      this.loading = false
    },
    async submit (info) {
      if (typeof info.imageUrl !== 'string') {
        info.imageUrl = await saveFile(info.imageUrl)
      }
      info.contactInfo = {
        legalName: info.legalName,
        addressLine1: info.addressLine1,
        addressLine2: info.addressLine2,
        city: info.city,
        postalCode: info.postalCode,
        country: info.country,
        taxNumber: info.taxNumber,
        longitude: info.longitude,
        latitude: info.latitude
      }
      info.displayInfo = {
        name: info.name,
        description: info.description,
        imageUrl: info.imageUrl,
        color: info.color
      }
      await updateBusinessLayerDisplayInfo(info)
    },
    editItem () {
      this.showEditDialog = true
    }
  }
}
</script>

<template>
  <div>
    <loading-provider :loading="loading">
      <div class="d-flex">
        <display-info
          :info="this.blInfo?.displayInfo"
          :width="'50%'"
          @click="editItem"
        />
        <v-spacer />
        <contact-info
          :info="this.blInfo?.contactInfo"
          :width="'50%'"
          class="ml-4"
        />
      </div>
      <div class="d-flex align-end">
        <OrganizationCard
          :info="blInfo"
          @reload="reload()"
        />
        <v-card
          :height="$vuetify.breakpoint.mobile ? 150 : 200"
          :width="$vuetify.breakpoint.mobile ? 150 : 200"
          class="pa-2 mt-2 ml-4"
          color="#fafbfc"
          elevation="0"
        >
          <qrcode-vue
            :size="$vuetify.breakpoint.mobile ? 140 : 190"
            :value="QRCode"
            level="H"
          />
        </v-card>

        <v-spacer />
        <div>
          <v-btn
            class="warning"
            elevation="0"
            @click="openPortal"
          >
            在 Portal 管理成员
          </v-btn>
          <v-btn
            :loading="btnLoading"
            class="info ml-4"
            elevation="0"
            @click="downloadQR"
          >
            下载qrCode
          </v-btn>
          <v-btn
            class="primary ml-4"
            elevation="0"
            @click="editItem"
          >
            修改
          </v-btn>
        </div>
      </div>
    </loading-provider>

    <v-dialog
      v-model="showEditDialog"
      max-width="800px"
    >
      <base-form
        :editing-object="blInfo"
        :schema="schema"
        class="pa-4"
        @close="showEditDialog=false"
        @submit="submit"
      />
    </v-dialog>
  </div>
</template>

<style scoped>

</style>
